"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationKeys = void 0;
const translationKeys = exports.translationKeys = {
  AreYouSureToLeaveConversation: 'AreYouSureToLeaveConversation',
  ChatBot: 'ChatBot',
  ChatIsActive: 'ChatIsActive',
  ChatIsNotAvailableDueToOpeningHours: 'ChatIsNotAvailableDueToOpeningHours',
  ChatWithUs: 'ChatWithUs',
  Customer: 'Customer',
  EmailChatHistory: 'EmailChatHistory',
  No: 'No',
  PrintChatHistory: 'PrintChatHistory',
  Send: 'Send',
  Yes: 'Yes'
};
